import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  return (
    <header className="rcs-header">
      <div className="logo">RCS TOPUP & BILLING ENTITY</div>
      <nav className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/services">Services</Link>
        <Link to="/new">New</Link> 
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>

      </nav>
    </header>
  );
};

export default Header;
